import React,{Component} from 'react';
import WorkTagView from './WorkTagView';
import Notification from './Notification';
import WorkerListItem from './WorkerListItem';

import packageJson   from '../package.json';
class WorkerListView extends Component{
 
  constructor(props){
    super(props);
  }

  render(){
    const workers = this.props.workers != undefined ? this.props.workers.map( (i,index) => {
      return <WorkerListItem changeWorker={this.props.changeWorker} deleteWorker={this.props.deleteWorker} worker={i} key={index} showInMap={this.props.showInMap} isAdmin={this.props.isAdmin}/>
    }): null;
      return (
        <>
        <div className="workersListHeader alert alert-info"><span className="version">ver.{packageJson.version}</span>Aktiiviset työntekijät<span className="glyphicon glyphicon-user pull-right" onClick={this.props.changePasswordView}> &nbsp;</span></div>
        <ol className="workerList">
        {workers}
        </ol>
    </>
    )


  }
}
export default WorkerListView;
